import React from 'react'
import ReactDOM from 'react-dom/client'
import { HeadloProviderV2 } from 'headlo-auth'
import App from './App'
import { SignInGate } from './SignInGate'
import { createCapacitorAuthAdapter } from './capacitor-auth-adapter'
import { WhoAmIProvider } from './WhoAmIContext'
import { ShopProvider } from './ShopContext'

// headlo-mobile entrypoint. Same shape as headlo-desktop/src/renderer/main.tsx
// — HeadloProviderV2 with a platform-specific adapter, wrapped by a
// SignInGate that blocks children until auth completes.

const publishableKey = import.meta.env.VITE_HEADLO_PUBLISHABLE_KEY as string
const issuer         = (import.meta.env.VITE_HEADLO_AUTH_ISSUER as string | undefined) ?? 'https://auth.headlo.com'

if (!publishableKey) {
  document.getElementById('root')!.innerHTML = `
    <div style="padding:40px;color:#f5b7b7;background:#1e1e1e;height:100vh;font-family:sans-serif;">
      <h1 style="font-size:16px;">Missing VITE_HEADLO_PUBLISHABLE_KEY</h1>
      <p style="font-size:13px;color:#aaa;">Set it in <code>headlo-mobile/.env</code> and restart the dev server.</p>
    </div>
  `
} else {
  const platformAdapter = createCapacitorAuthAdapter()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <HeadloProviderV2
        publishableKey={publishableKey}
        issuer={issuer}
        platformAdapter={platformAdapter}
      >
        <SignInGate>
          <WhoAmIProvider>
            <ShopProvider>
              <App />
            </ShopProvider>
          </WhoAmIProvider>
        </SignInGate>
      </HeadloProviderV2>
    </React.StrictMode>,
  )
}
